import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

export default new Vuetify({
  breakpoint: {
    thresholds: {
      xs: 601,
    },
  },
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#1E76BD',
        secondary: '#BE9150',
        accent: '#D393AA',
        darkaccent: '#043F67',
        lightaccent: '#faf7f3',
        error: '#e60909',
        info: '#2196F3',
        formhighlight: '#FBFDFF',
        success: '#00A73E',
        warning: '#FFC107',
        sienna: '#E4674B',
        groundbg: '#E5E5E5',
        mainbg: '#FFFFFF',
        secondarybg: '#1B263B',
        highlightbg: '#FAFAFA',

        title: '#5C5C5C', //"#7C7C96",
        text: '#333333',
        navlink: '#FFF',

        gray: '#9C9A9A',
        coldgray: '#ededef',
        lightgray: '#fcfcfc',
        'light-blue': '#1E76BD',
        tundora: '#4D4D4D',
        alabaster: '#FBFBFB',
        'green-pea': '#196A35',
        'dove-gray': '#6F6F6F',
        'gray-solid': '#808080',
        zumthor: '#EAF2FF', // #E8F0FF
        waterloo: '#7C7C96',
        mercury: '#E7E5E5',
        alto: '#D8D8D8',

        'wild-sand': '#F5F5F5',
        'alice-blue': '#F7FBFF',
        russett: '#775858',
        gigas: '#4C44A7',
        'mine-shaft': '#353535',
        zircon: '#EFF2FF',
        zinc: '#fdecd7',
        'pale-rose': '#FFE9F4',
        linen: '#FBF5ED',
        prim: '#F2EBF2',
        'la-palma': '#279D14',
        flamingo: '#F15642',
        kumera: '#966B2E',
        stratos: '#000F3D',
        geyser: '#D3DBE2',
        'scotch-mitch': '#FFF7DA',
        'persian-red': '#CA2E2E',
        rajah: '#F8B585',
        nobel: '#B5B5B5',
        scorpion: '#5E5E5E',
        'pattens-blue': '#D8EDFF',
        emperor: '#535353',
        gallery: '#EBEBEB',
        'swans-down': '#D3ECE5',
        'link-water': '#DEE6F7',
        'algae-green': '#98E6B2',
        'vista-white': '#FDFCFA',
        saltpan: '#F7FBF8',
        'gray-nurse': '#E8EEEB',
        marzipan: '#F8D6A4',
        corduroy: '#5B655F',
        dixie: '#EA9414',
        laurel: '#0A8A07',
        'snowy-mint': '#CCFCCA',
        aquamarine: '#9FFFC6',
        'your-pink': '#FECCCC',
        feta: '#d8fbd7',
        azalea: '#fbe2e2',
        shilo: '#e4adad',
        ebb: '#f1eded',
        'we-peep': '#f9e8e8',
        cardinal: '#ca2424',
        mandy: '#E14B4A',
        jewel: '#107948',
        silver: '#BEBEBE',
      },
    },
  },
  icons: {
    iconfont: 'mdi',
  },
});
